import { ReactComponent as Warning } from "assets/icons/warning-primary-circule.svg";
import { useTranslation } from "react-i18next";

const Rules = () => {
  const { t } = useTranslation();
  return (
    <div className="mb-3 flex justify-center items-center">
      <Warning className="[&>path]:fill-gray--1" />
      <span className="caption-12px-medium text-gray-0 mr-2">
        {t("pma-onboarding.prepayment-rules")}
      </span>
    </div>
  );
};
export default Rules;
